module.exports = __webpack_public_path__ + "img/miniprogram.43bc3829.png";